<div class="full-width mb-2 p-2 pl-4 pr-4 bg-{{theme.bright}} bright-12">
  <div class="full-size d-flex align-items-center">
    <img [src]="iconFolder" class="icon non-selectable" />
    <ng-container *ngFor="let part of pathParts; index as i">
      <span *ngIf="i>0" class="separator text-{{theme.brightContrast}}">
        <i class="fas fa-chevron-right"></i>
      </span>
      <button class="btn btn-link" (click)="navigate(part.path)">
        {{part.name}}
      </button>
    </ng-container>
  </div>
</div>
